// extracted by mini-css-extract-plugin
export default {"trigger":"logo_trigger__3BCcg","birdTrigger":"logo_birdTrigger__GXsIU"};